<div class="flex min-h-screen items-center justify-center">
  @if (status() === 'loading') {
  <div class="flex flex-col items-center justify-center gap-3">
    <div class="size-8 animate-spin rounded-full border-2 border-zinc-200 border-t-primary dark:border-zinc-700 dark:border-t-primary"></div>
    <p class="text-sm text-secondary">Connecting your TikTok for Business account…</p>
  </div>
  } @else {
  <div class="flex flex-col items-center justify-center px-6 text-center">
    <div class="flex items-center justify-center size-14 rounded-2xl bg-rose-100 dark:bg-rose-900/20 mb-4">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="size-7 text-rose-500 dark:text-rose-400">
        <circle cx="12" cy="12" r="10"/>
        <path d="M12 8v4"/>
        <path d="M12 16h.01"/>
      </svg>
    </div>
    <h3 class="text-sm font-semibold text-primary">TikTok connection failed</h3>
    <p class="mt-1 text-xs text-secondary max-w-[220px]">{{ errorMessage() }}</p>
    <div class="mt-6">
      <a routerLink="/my-brand/social-ads"
          class="inline-flex items-center rounded-md bg-primary px-4 py-2 text-sm font-semibold text-white hover:bg-primary/85 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary transition-colors">
        Back to Social Ads
      </a>
    </div>
  </div>
  }
</div>
